<template>
  <div
    class="accordion__item"
    :class="{ 'is-active': active }"
    v-on:click="handleChange"
  >
    <div class="accordion__item-title">
      <h5>
        <slot></slot>
      </h5>
      <div class="accordion__item-icon">
        <div class="accordion__item-icon-inner"></div>
      </div>
    </div>
    <div class="accordion__item-content">
      <p>
        <slot name="content"></slot>
      </p>
    </div>
  </div>
</template>

<script>
import { gtmTracking } from "@/functions/gtm-tracking";

export default {
  name: "AccordionItem",
  props: {
    active: {
      type: Boolean,
    },
  },

  methods: {
    handleChange() {
      const titleEl = this.$el.querySelector(".accordion__item-title h5");
      const label = titleEl
        ? (titleEl.innerText || titleEl.textContent || "").replace(/\s+/g, " ").trim()
        : "Accordion";
      const contextEl = this.$el.closest("[data-gtm-context]");
      const context = contextEl
        ? contextEl.getAttribute("data-gtm-context") || ""
        : "";
      gtmTracking("Accordion Click", label, context)();
      this.$emit("setSelected");
    },
  },
};
</script>
